import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyRelationsRow',
  props: {
    type: { default: 'select' },
    label: null,
    items: null,
    fieldNames: null,
    currentValue: { default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ['valueChanged'],
  setup(__props: any, { emit }) {

const props = __props as { type:string, label:string, items?:{ id:number, name:string }[], fieldNames?:{ labelPrefix:string|undefined, label:string, value:string }, currentValue:string|number|null, loading:boolean };




const selectedValue = ref<string|number|null>(null)

onMounted(() => {
  selectedValue.value = props.currentValue
})

watch(() => props.currentValue, () => {
  selectedValue.value = props.currentValue
})

function valueChanged () : void {
  emit('valueChanged', selectedValue.value)
}

function filterItems (input:string, item:{ key:string, value:number }) {
  return item.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "survey-relation-row" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 8}
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(props.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          (props.type === 'select')
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 0,
                filterOption: filterItems,
                loading: props.loading,
                disabled: props.loading,
                value: selectedValue.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
                onChange: valueChanged
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: null }, {
                    default: _withCtx(() => [
                      _createTextVNode("-")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item[props.fieldNames.value],
                      key: item[props.fieldNames.value]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.fieldNames.labelPrefix ? props.fieldNames.labelPrefix + item[props.fieldNames.label] : item[props.fieldNames.label]), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "disabled", "value"]))
            : (props.type === 'text')
              ? (_openBlock(), _createBlock(_component_a_input, {
                  key: 1,
                  type: "text",
                  value: selectedValue.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedValue).value = $event)),
                  onBlur: valueChanged
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})